import React from "react";
import "./WhyCostaBlanca.css";
import CTASecondary from "../CTASecondary";
import whycostablanca from "../../img/whycostablanca.png";

function WhyCostaBlanca() {
  return (
    <div className="WhyCostaBlanca">
      <div className="WhyCostaBlanca__leftblock">
        <h1>Why Costa Blanca?</h1>
        <p>
          The Costa Blanca is a region on the southeastern coast of Spain, known
          for its beautiful beaches, charming coastal towns, and sunny
          Mediterranean climate.
        </p>

        <a href="/press">
          <CTASecondary label="View more" />
        </a>
      </div>

      <div className="WhyCostaBlanca__rightblock">
        <img src={whycostablanca} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default WhyCostaBlanca;
